<script lang="ts" setup>
import type { Configuration } from '~/types/configurator'

defineProps<{
  activePanel: string | null
  optionalBaseParts: Map<
    number,
    {
      surfaceOption: Configuration['surfacesOptions'][number]
      basePartDeselected: boolean
    }
  >
}>()

const emit = defineEmits<{
  toggleOptionalBasePart: [partCategoryNid: number]
}>()
</script>

<template>
  <template
    v-for="[key, optionalBasePart] in Array.from(optionalBaseParts)"
    :key="key"
  >
    <div
      v-if="activePanel === OPTIONAL_BASE_PARTS_PANEL + key"
      class="grid min-h-16 w-full grid-cols-2 items-center bg-white px-5 py-2 hover:cursor-pointer hover:bg-neutral-100 2xl:min-h-20 2xl:pl-5"
      @click="
        () => {
          emit('toggleOptionalBasePart', key)
        }
      "
    >
      <p class="font-pragmatica-ext text-lg font-bold">
        {{ configuratorUtils.getOptionalBasePartTitle(optionalBasePart) }}
      </p>
      <div
        class="flex h-12 w-12 items-center justify-center justify-self-end 2xl:h-16 2xl:w-16"
      >
        <UToggle :model-value="!optionalBasePart.basePartDeselected" />
      </div>
    </div>
  </template>
</template>
